<template>
    <!-- Page Content Wrapper -->
    <div v-if="permissionsArray.includes('can_manage_users')" id="page-content-wrapper" class="admin-content-area">
        <div class="container-fluid xyz">
        <div class="page-header-top-container">
          <div class="page-name">Classes</div>
          <button
                  type="submit"
                  v-on:click.prevent="AddClassMaster()"
                  class="btn btn-primary waves-effect pull-right"
          >Add</button>
        </div>

        <!--page content-->
            <div class="admin-page-content">
                <!--Forms-->
                <div class="forms-container default-bx-shadow">
                    <div class="row no-margin">
                        <draggable v-model="rows" :options="dragOptions" @start="drag=true" @change="changePosition">
                            <div v-for="(element, index) in rows" :id="'menu-'+element.id" :key="'menu-'+element.id" class="edit-menu">
                                <img class="drag-handle" src="/static/images/app-bar-icon.png">
                                <p>{{ element.name }}</p>
                                <div class="menu-actions">
                                    <router-link
                                        class="btn edit-btn-vvg waves-effect"
                                        title="Edit Class"
                                        v-bind:to="{name: 'UpdateClassMaster',params:{id:element.slug}}"
                                    >
                                    <i class="fa fa-pencil" aria-hidden="true"></i>
                                </router-link>
                                <button
                            v-on:click="deleteClassMaster(element.slug)"
                            class="btn edit-btn-vvg waves-effect fa fa-trash"
                            title="Delete Class"
                    >
                        <i class="fa fa-trash-o" aria-hidden="true"></i>
                    </button>
                                    <!-- <a href="javascript:void(0)" id="edit-menu" v-on:click="toggleEditMenu('menu-'+element.id, index)"><img src="/static/images/edit-icon.png"></a>
                                    <a href="javascript:void(0)" id="delete-menu" v-on:click="deleteMenu(element.id)"><img src="/static/images/delete-icon.png"></a> -->
                                </div>
                            </div>
                        </draggable>
                    </div>
                </div>
                <!-- Forms -->
            </div>
        </div>
        <app-footer></app-footer>
    </div>
    <div v-else>
        <no-permission></no-permission>
    </div>
    <!-- Page Content Wrapper -->
</template>

<script>
    var self;
    import Vue from "vue";
    import Footer from "@/components/partials/Footer";
    import EventBus from ".././event-bus";
    import { commonMixins } from "../../mixins/commonMixins";
    import { HTTP } from "../../http-common.js";
    import VueGoodTable from "vue-good-table";
    import NoAccessPermission from '../NoAccessPermission';
    import vSelect from 'vue-select';

    import draggable from 'vuedraggable';
    Vue.use(draggable);

    Vue.use(VueGoodTable);
    export default {
        name: "ListUser",
        components: {
            "app-footer": Footer,
            "no-permission" : NoAccessPermission,
            'v-select': vSelect,
            draggable,
        },
        mixins: [commonMixins],
        data() {
            return {
                roleId: 0,
                firstLoad: 0,
                columns: [
                    {
                        label: "Name",
                        field: "name",

                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Name", // placeholder for filter input
                            filterValue: "", // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: "Actions",
                        field: "action",
                        html: true,
                        sortable: false,
                        thClass: "disable-sorting"
                    }
                ],
                rows: [],
                totalRecords: 0,
                serverParams: {
                    columnFilters: {},
                    page: 1,
                    perPage: 25,
                    sort: {
                        field: "id",
                        type: "asc"
                    },
                    perPageDropdown : [],
                },
                recordsCounts: "",
                selectedRows: 0,
                permissionsArray: ['can_manage_users'],

                displayPageTask: 7,
                jumpToPageTask: 0,
                pageCompareTask: 0,
                paginationDisplayRowsTask: '',
            };
        },
        beforeMount: function() {
            self = this;
            EventBus.$emit("menu-selection-changed", "listclassmasterinfo");
        },
        mounted: function() {
            //self.getUserRole();
            self.getUserPermissions();

            self.loadClasses();
        },
        computed: {
            dragOptions() {
                return {
                    group: 'menu',
                    handle: ".drag-handle",
                }
            },

        },

        methods: {
            AddClassMaster: function() {
                self.$router.push("/add-class-master");
            },
            deleteClassMaster: function(id) {
                var classArr = [];
                var config = {
                    headers: {
                        Authorization:"Bearer " + localStorage.getItem("api_token")
                    }
                };

                if (id) {
                    classArr.push(id);
                } else {
                    var selectedUser = this.$refs["listMasterClass"].selectedRows;
                    for (var i = 0; i < selectedUser.length; i++) {
                        classArr.push(this.$refs["listMasterClass"].selectedRows[i].id);
                    }
                }
                var fields = {
                    deleteArr: classArr
                };

                self.$swal({
                        title: "Are you sure?",
                        text: "You can't revert your action",
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonText: "Yes Delete it!",
                        cancelButtonText: "No, Keep it!",
                        showCloseButton: true,
                        showLoaderOnConfirm: true
                    })
                    .then(result => {
                        if (result.value) {
                            HTTP.post("/class-master/delete", fields, config)
                                .then(function(response) {
                                    self.loadClasses();
                                })
                                .catch(function(err) {
                                    if (err.response.status == 0) {
                                        self.error = "Remote server can not be reachable";
                                    } else {
                                        //redirect to login page if user not authenticated
                                        if (err.response.status == 401) {
                                            //clear previous data
                                            localStorage.removeItem("user_obj");
                                            localStorage.removeItem("api_token");
                                            localStorage.removeItem("profile_image");
                                            //self.$router.push("/login");
                                            //EventBus.$emit("logged-in", true, "", "");
                                        }
                                    }
                                });
                            self.$swal(
                                "Deleted",
                                "You have successfully deleted Class",
                                "success"
                            );
                        } else {
                            self.$swal("Cancelled", "Your file is still intact", "info");
                        }
                    });
            },
            changePosition: function() {
                /* console.log(JSON.stringify(self.imageList)); */
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                };
                var fields = {
                    classMasterList : self.rows,
                }
                HTTP.post("/class-master/position/change", fields, config)
                    .then(function (data) {
                        self.loadClasses();
                    })
                    .catch(function (error) {
                        if (err.response.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (err.response.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("api_token");
                                localStorage.removeItem("profile_image");
                                //EventBus.$emit("logged-in", true, "", "");
                                //self.$router.push("/login");
                            }
                            self.error = err.response.data.message;
                        }
                    })
            },
            

            loadClasses: function() {
                self.firstLoad = 1;
                var newPage = Math.ceil(self.totalRecords / self.serverParams.perPage);
                if (newPage) {
                    if (newPage < self.serverParams.page) {
                        self.serverParams.page = newPage;
                    }
                }
                var config = {
                    headers: {
                        Authorization:"Bearer " + localStorage.getItem("api_token")
                    },
                    params : {
                        page: self.serverParams.page,
                        perPage: self.serverParams.perPage,
                        filters: self.serverParams.columnFilters,
                        messageData: self.message,
                        sort: self.serverParams.sort,
                        load:'all'
                    }
                };
                /*var fields = {
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: self.serverParams.columnFilters,
                    messageData: self.message,
                    sort: self.serverParams.sort
                };*/
                HTTP.get("/class-master/list", config)
                    .then(function(response) {
                        if (response.data.code == "200") {
                            self.rows = response.data.content.row;
                            self.totalRecords = response.data.content.totalRecords;
                            // $('.loading-container').hide();
                        }
                        self.paginationDisplayRowsTask = self.getRecords(self.serverParams.page, self.serverParams.perPage, self.totalRecords);
                    })
                    .catch(function(err) {
                        if (err.response.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (err.response.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("api_token");
                                localStorage.removeItem("profile_image");
                                //EventBus.$emit("logged-in", true, "", "");
                                //self.$router.push("/login");
                            }
                            self.error = err.response.data.message;
                        }
                    });
            }
        }
    };

    EventBus.$on("role", function(isLogin, roleId, roleName) {
        if (typeof self != "undefined") {
            self.roleId = roleId;
        }
    });

    EventBus.$on("permissions", function(isLogin, permissionArray) {
        if (typeof self != "undefined") {
            for (var i = 0; i < permissionArray.length; i++) {
                self.permissionsArray.push(permissionArray[i].name);
            }
        }
    });
</script>
<style>
.vertical .swiper-container{
    height: 300px;
}
.swiper-slide.text {
	font-size: 18px !important;
	text-align: left !important;
	height: auto;
	-webkit-box-sizing: border-box;
	box-sizing: border-box;
	padding: 30px;
}

.swiper-slide.text > .content > .title {
	margin: 0;
	text-align: center;
	margin-bottom: .75em;
}

.swiper-slide.text > .content > p,
  .swiper-slide.text > .content blockquote {
	line-height: 2;
	text-indent: 2em;
}

.swiper-slide.text > .content blockquote {
	background-color: #ddd;
	margin-left: 2em;
}
</style>


// WEBPACK FOOTER //
// src/components/ClassMaster/ListMasterClass.vue